export default __webpack_public_path__ + "static/Riina1-ea2f20d7703eeb3bf0cd5570e3c6a946.png";